export enum MessageBoxPrimaryButton {
    Confirm,
    Deny,
    Cancel
}
